<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import snackbarMixin from '@/mixins/snackbar';

export default {
  name: 'pendingPurchaseDetailDialog',
  mixins: [snackbarMixin],
  props: {
    isCreateMode: {
      type: Boolean,
    },
    item: {
      type: Object,
      default: Object,
    },
  },
  data() {
    return {
      isLoading: false,
      visible: false,
      hasError: false,
      formData: {},
    };
  },
  computed: {
    ...mapGetters('pendingPurchaseDetail', ['singularName']),
  },
  created() {
      this.formData = Object.assign({}, this.item);
  },
  mounted() {
    this.visible = true;
    this.initializeData();
  },
  beforeDestroy() {
    this.visible = false;
  },
  methods: {
    ...mapActions('satinAlmaOdemeTalep',['getDetail', 'reject', 'approve']),
    ...mapMutations('satinAlmaOdemeTalep', ['getList']),
    fetchData() {
      this.isLoading = true;
      this.getDetail(this.formData.pfaaliyet)
        .then((data) => {
          this.item = data.data;
          this.isInitialized = true;
        })
        .catch(() => {
          this.hasError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    rejectRecord(){
      this.isLoading = true;
      this.reject(this.formData.pfaaliyet)
        .then(() => {
          this.showSuccessMessage(`${this.formData.pfaaliyet} numaları bekleyen satın alma ödeme talebi reddedilmiştir.`);
          this.$emit('refresh');
        })
        .catch((err) => {
          this.showErrorMessage(err.response && err.response.data);
        })
        .finally(() => {
          this.isDeleting = false;
          this.isLoading = false;
          this.close();
        });
    },
    approveRecord() {
      this.isDeleting = true;
      this.approve(this.formData.pfaaliyet)
        .then(() => {
          this.showSuccessMessage(`${this.formData.pfaaliyet} numaralı satın alma ödeme talebi onaylanmıştır.`);
          this.$emit('refresh');
        })
        .catch((err) => {
          this.showErrorMessage(err.response && err.response.data);
        })
        .finally(() => {
          this.isDeleting = false;
          this.isLoading = false;
          this.close();
        });
    },
    initializeData() {
      this.isLoading = true;
      Promise.all([this.getDetail(this.formData.pfaaliyet)])
        .then(([detail]) => {
          this.item = detail.data;
          this.isInitialized = true;
          this.isLoading = false;
        }, () => {
          this.hasError = true;
          this.isLoading = false;
        });
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<template>
  <v-dialog v-model="visible" persistent max-width="1080px">
    <v-card>
      <v-card-title>
        {{item.odemeYapilacakFirma}} - {{item.proje}}
      </v-card-title>
      <v-flex xs12 style="margin-left:10px">
        {{ item.konu }}
        <br />
        <b>Faaliyet No:</b> {{ item.faaliyetNo }}
        <b>Talep No:</b> {{ item.talepNo }}
        <b>Talebi Yapan Kullanıcı:</b> {{ item.talebiYapanKullanici }}

      </v-flex>

      <div class="container" style="background-color:rgb(229 231 235)">
        <div class="row">
          <div class="col">  
            <b>Ödeme Yapılacak Firma:</b> {{ item.odemeYapilacakFirma }}
          </div>
        </div>
        <div class="row">
          <div class="col">  
            <b>Ödeme Açıklaması:</b> {{ item.odemeAciklamasi }}
          </div>
        </div>
        <div class="row">
          <div class="col">
            <b>Ödemeyi Yapacak Firma:</b> {{ item.odemeyiYapacakFirma }}
          </div>
        </div>
        <div class="row">
          <div class="col">
            <b>Ödeme Yapılacak Tarih:</b> {{ item.odemeYapilacakTarih|dateTimeView  }}
          </div>
        </div>
        <div class="row">
          <div class="col">
            <b>Ödeme Türü:</b> {{ item.odemeTuru }}
          </div>
        </div>
        <div class="row">
          <div class="col">
            <b>Ödeme Tutarı:</b> {{ item.odemeTutari|toCurrency }} {{ item.döviz }}
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row">
          <div class="col-6" style="background-color:rgb(167 243 208">
              <b>Birinci Seviye Onay:</b> {{ item.birSeviyeOnay }}
              <br />
              <b>Birinci Seviye Onaylayacak:</b> {{ item.birSeviyeOnaylayacak }}
              <br />
              <b>Birinci Seviye Onaylayan:</b> {{ item.birSeviyeOnaylayan }}
          </div>
          <div class="col-6" style="background-color:rgb(229 231 235)">
              <b>İkinci Seviye Onay:</b> {{ item.ikiSeviyeOnay }}
              <br />
              <b>İkinci Seviye Onaylayacak:</b> {{ item.ikiSeviyeOnaylayacak }}
              <br />
              <b>İkinci Seviye Onaylayan:</b> {{ item.ikiSeviyeOnaylayan }}
              <br />
          </div>
        </div>
      </div>
      <v-card-actions>
        <v-spacer />
        <v-btn :loading="isLoading" @click="rejectRecord" color="red lighten-3" dark>
            Reddet
        </v-btn>
        <v-btn :loading="isLoading" @click="approveRecord" color="green lighten-3" dark>
        Onayla
        </v-btn>
        <v-btn color="red lighten-3" dark @click="close">
          Kapat
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
